document.addEventListener('DOMContentLoaded', () => {
  const dd = document.querySelector('.account-dropdown');
  if (!dd) return;

  const btn  = dd.querySelector('.account-dropdown__toggle');
  const menu = dd.querySelector('.account-dropdown__menu');

  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function positionMenu() {
    // Nur für Mobile nötig – Desktop macht CSS (zentriert)
    if (!isMobile()) return;
    const r = btn.getBoundingClientRect();
    const gap = 6;
    const top = Math.round(r.bottom + gap); // Viewport-Position
    menu.style.setProperty('--ad-menu-top', `${top}px`);
  }

  function openMenu() {
    positionMenu();
    dd.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    dd.classList.remove('is-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  // Toggle
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    dd.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  // Klick außerhalb schließt
  document.addEventListener('click', (e) => {
    if (!dd.contains(e.target)) closeMenu();
  });

  // ESC schließt
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  // --- NEU: Beim Scrollen IMMER schließen (mobile & desktop)
  window.addEventListener('scroll', () => {
    if (dd.classList.contains('is-open')) closeMenu();
  }, { passive: true });

  // Bei Resize ebenfalls schließen (sichere Variante)
  window.addEventListener('resize', () => {
    if (dd.classList.contains('is-open')) closeMenu();
  }, { passive: true });
});
